// action-keys.js
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SET_INSURANCES = 'SET_INSURANCES';
export const ADD_INSURANCE = 'ADD_INSURANCE';
export const REMOVE_INSURANCE = 'REMOVE_INSURANCE';
export const SET_ADDITIONAL_INFO = 'SET_ADDITIONAL_INFO';
export const SET_NAME = 'SET_NAME';
export const SET_BIRTHDATE = 'SET_BIRTHDATE';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_ADDRESS_VALID = 'SET_ADDRESS_VALID';
export const SET_MOBILE = 'SET_MOBILE';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_CONTACT_OPTION = 'SET_CONTACT_OPTION';
export const SET_CONTACT_DATE_TIME_OPTION = 'SET_CONTACT_DATE_TIME_OPTION';
export const SET_CONTACT_DATE = 'SET_CONTACT_DATE';
export const SET_CONTACT_TIME = 'SET_CONTACT_TIME';
export const SET_RESOURCES = 'SET_RESOURCES';
export const SET_MINIMAL = 'SET_MINIMAL';
export const SET_UI_STATUS = 'SET_UI_STATUS';
export const SET_DISPLAY_ERROR = 'SET_DISPLAY_ERROR';
export const SET_FORM_STEP = 'SET_FORM_STEP';
export const SET_IS_SUBMITTING = 'SET_IS_SUBMITTING';
export const SET_ERROR_TEXT = 'SET_ERROR_TEXT';
export const SET_SUBMIT_ENDPOINT = 'SET_SUBMIT_ENDPOINT';
export const SET_RECEIPT_ENDPOINT = 'SET_RECEIPT_ENDPOINT';
export const SET_POST_FORM = 'SET_POST_FORM';
export const SET_FLOW = 'SET_FLOW';
export const SET_SHOW_INSURANCES = 'SET_SHOW_INSURANCES';
export const SET_OPEN_TIMES_ENDPOINT = 'SET_OPEN_TIMES_ENDPOINT';
export const SET_OPENING_TIMES = 'SET_OPENING_TIMES';
export const SET_SUBMIT_GENESYS_ENDPOINT = 'SET_SUBMIT_GENESYS_ENDPOINT';
export const SET_SUBMIT_INSURANCE_GUIDE_ENDPOINT = 'SET_SUBMIT_INSURANCE_GUIDE_ENDPOINT';
